var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5"},[(!_vm.isLoged)?_c('login'):_vm._e(),_c('orders',{directives:[{name:"show",rawName:"v-show",value:(_vm.isItDriver || _vm.isItDukandar),expression:"isItDriver || isItDukandar"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }